import { MouseEvent, SyntheticEvent } from "react";

interface MuiCancellableEvent extends SyntheticEvent {
	defaultMuiPrevented?: boolean;
}

/** stop normal event processing */
export function preventDefaultBehaviour(event: MouseEvent<HTMLElement | SVGSVGElement>): void {
	event.stopPropagation();
	event.preventDefault();
}

/**
 * stop MUI event, prevent default and MUI default and stop propagation
 */
export function stopMuiEvent(ev: MuiCancellableEvent) : void {
	ev.preventDefault();
	ev.stopPropagation();
	ev.defaultMuiPrevented = true;
}
